import { pushToDataLayer } from '../datalayer';
import { TrackClickCtaArgs, TrackInstallActionsArgs } from '../types';

export const trackInstallActions = ({ event, eventType, gtmSource, addonOptions = [] }: TrackInstallActionsArgs) => {
  const addonOptionsPayload = addonOptions
    .filter((option): option is NonNullable<typeof option> => !!option)
    .map(option => ({
      option: option?.title,
      price: typeof option?.priceToShow === 'number' ? option.priceToShow : option?.priceInc,
    }));

  pushToDataLayer({
    event,
    type: eventType,
    location: gtmSource,
    addon_options: addonOptionsPayload,
  });
};

export const trackClickCta = ({ linkText, linkUrl, location }: TrackClickCtaArgs) => {
  pushToDataLayer({
    event: 'click_cta',
    link_text: linkText,
    link_url: linkUrl,
    location,
  });
};
